module.exports = __webpack_public_path__ + "static/media/dhaib.3fc6ed45.jpg";